import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { LegacyPageComponent } from 'src/app/base/legacy-page/legacy-page.component';
import { Beneficio, BeneficioCategoria, beneficioCategoriaTodos, ContenidoStatus } from 'src/common/contenido';
import { BeneficioActions, BeneficioActionTypes, BeneficioPageCancelled } from './beneficio.actions';


export interface BeneficioState extends EntityState<Beneficio> {
	initialized: boolean;
	beneficiosReady: boolean;
	nextPageNum: number;
	pageSize: number;
	morePagesToLoad: boolean;
	status: ContenidoStatus;
	cleared: boolean;
	categorias: BeneficioCategoria[];
	categoriaSelected: BeneficioCategoria;
	categoriasReady: boolean;
}

export const beneficioAdapter: EntityAdapter<Beneficio> = createEntityAdapter<Beneficio>();

const TODOS_TIPO_CATEGORIA: string = "TODOS";

const initialBeneficioState: BeneficioState = beneficioAdapter.getInitialState({
	initialized: false,
	beneficiosReady: true,
	nextPageNum: 0,
	pageSize: 3,
	morePagesToLoad: true,	// Es sólo actualizado por los actions BeneficioPageRequested, BeneficioPageCancelled, BeneficioPageRight
	status: null,
	cleared: false,
	categorias: null,
	categoriaSelected: beneficioCategoriaTodos,
	categoriasReady: true
});

export function beneficioReducer( state: BeneficioState = initialBeneficioState, action: BeneficioActions ): BeneficioState {
	let payload: any;
	let status: ContenidoStatus;

	switch( action.type ) {
		case BeneficioActionTypes.BeneficioPageRequested:
			return { ...state, cleared: false, beneficiosReady: false };
		case BeneficioActionTypes.BeneficioPageLoaded:
			payload = action["payload"];
			let cleared: boolean = payload["cleared"];
			status = payload["status"];
			let nextPageNum: number = payload["nextPageNum"];
			let beneficio: Beneficio[] = payload["beneficio"];

			if( cleared )
				state = beneficioAdapter.removeAll( state );

			return beneficioAdapter.addMany( beneficio, {
				...state,
				initialized: true,
				beneficiosReady: true,
				nextPageNum,
				status,
				cleared,
				morePagesToLoad: status.qty - state.ids.length - beneficio.length > 0
			});
		case BeneficioActionTypes.BeneficioPageCancelled:
			payload = action["payload"];
			status = payload["status"];

			// Si status == null => hubo un problema con el status, dejo el state como está			
			if( status != null && status.qty == 0 ) {
				state = beneficioAdapter.removeAll( state );
				state = { ...state, cleared: false, status, morePagesToLoad: false };
			}

			return  { ...state, initialized: true, beneficiosReady: true };
		case BeneficioActionTypes.BeneficioPageRight:
			return { ...state, initialized: true, beneficiosReady: true, cleared: false };			
		
		case BeneficioActionTypes.BeneficioCategoriasRequested:
			return { ...state, categoriasReady: false };
		case BeneficioActionTypes.BeneficioCategoriasLoaded:
			let categorias: BeneficioCategoria[] = action["payload"]["categorias"];
			let todoCategoria: BeneficioCategoria = categorias.find( categoria => categoria.tipo == TODOS_TIPO_CATEGORIA );
			return { ...state, categorias, categoriaSelected: todoCategoria, initialized: true, categoriasReady: true };
		case BeneficioActionTypes.BeneficioCategoriasCancelled:
		case BeneficioActionTypes.BeneficioCategoriasRight:
			return { ...state, initialized: true, categoriasReady: true }
		case BeneficioActionTypes.BeneficioCategoriaChangeRequested:
			return { ...state, categoriasReady: false };
		case BeneficioActionTypes.BeneficioCategoriaChangeLoaded:
			payload = action["payload"];
			state = beneficioAdapter.removeAll( state );
			return { ...state, categoriaSelected: payload["categoria"], nextPageNum: 0, status: null, categoriasReady: true, morePagesToLoad: true };
		case BeneficioActionTypes.BeneficioCategoriaChangeCancelled:
			return { ...state, categoriasReady: true };

		default:
			return state;
	}	
}

export const {
	selectAll,
	selectEntities,
	selectIds,
	selectTotal
} = beneficioAdapter.getSelectors();
